import { memo } from "react"

import styled, { css } from "styled-components"

import { borderRadius, spacing, size } from "@izettle/otto"

import { InputBase } from "../../input-base"
import { InputBaseContainerProps } from "../../input-base/types"
import { ZINDEX_SELECT_INPUT_FOCUSED } from "../helpers/constants"

// Here z-index is set to 30, to be above the list container, but only when focused upon.
// This is needed to hide the top part of the shadow of the list behind the input
const mixinZIndex = ({ isFocused }: InputBaseContainerProps) =>
  isFocused &&
  css`
    z-index: ${ZINDEX_SELECT_INPUT_FOCUSED};
  `

const cursorMixin = ({ isDisabled, isLoading }: InputBaseContainerProps) =>
  !isDisabled &&
  !isLoading &&
  css`
    cursor: pointer !important;
  `

export const InputBaseStyled = memo(styled(InputBase)`
  ${cursorMixin}
  ${mixinZIndex}
`)

export const ImageContainer = memo(styled.div`
  display: flex;
  align-items: center;
  height: 100%;
  padding-left: ${spacing.xSmall};
`)

export const StyledImage = memo(styled.img`
  display: flex;
  height: ${size.small};
  width: ${size.small};
  border-radius: ${borderRadius.medium};
`)
